import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import type { FormArray, FormGroup } from '@angular/forms';
import { assertIsNotNil } from '@pct-ts/assert';
import { isNil, isString } from '@pct-ts/typeguard';

export type FormArrayFormGroupKeys<T> = T extends FormArray<FormGroup<infer U>> ? U : never;

@Pipe({
  name: 'hasErrorInTranslationsFormArray',
  pure: false,
})
export class HasErrorInTranslationsFormArrayPipe implements PipeTransform {
  transform<
    T extends FormArray<FormGroup>,
    K extends keyof FormArrayFormGroupKeys<T>,
    LANGUAGE_CODE extends string,
  >(formArray: T, fields: K[]): Record<LANGUAGE_CODE, boolean> {
    return formArray.controls.reduce(
      (prev, curr) => {
        const control = curr.get('language');
        assertIsNotNil(control, 'Language control must exist in translations form group');
        const value = control.value as LANGUAGE_CODE;
        assertIsNotNil(
          value,
          'Language control value must be set for translations form validation',
        );

        prev[value] = fields.some(field => {
          if (!isString(field)) {
            return false;
          }
          const fieldControl = curr.get(field);
          return isNil(fieldControl) ? false : fieldControl.invalid && fieldControl.touched;
        });

        return prev;
      },
      {} as Record<LANGUAGE_CODE, boolean>,
    );
  }
}
